<template>
  <div id="app">
    Ship
    {{ this.$route.path }}
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style scoped>
</style>
